import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Text,
    VStack,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
} from '@chakra-ui/react';
import { usePartnerForm } from '../hooks/usePartnerForm';
import useDeletePartner from '../queries/useDeletePartner';

const DeletePartnerModal = ({ isOpen, onClose, resetToMainTable }) => {
    const { formData } = usePartnerForm();
    const { mutate: deletePartner, isPending } = useDeletePartner();

    const handleDelete = () => {
        if (formData?.id) {
            deletePartner(formData.id, {
                onSuccess: () => {
                    onClose();
                    if (resetToMainTable) {
                        resetToMainTable();
                    }
                },
            });
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Delete Partner</ModalHeader>
                <ModalBody>
                    <VStack spacing={4} align="stretch">
                        <Alert status="error">
                            <AlertIcon />
                            <VStack align="start" spacing={1}>
                                <AlertTitle>Warning: This action cannot be undone!</AlertTitle>
                                <AlertDescription>
                                    All data associated with this partner will be permanently deleted.
                                </AlertDescription>
                            </VStack>
                        </Alert>
                        <Text>
                            Are you sure you want to delete the partner{' '}
                            <strong>{formData?.name || formData?.entityName || 'Unknown'}</strong>?
                        </Text>
                        <Text fontSize="sm" color="gray.600">
                            Partner ID: {formData?.id}
                        </Text>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button
                        variant="ghost"
                        mr={3}
                        onClick={onClose}
                        isDisabled={isPending}>
                        Cancel
                    </Button>
                    <Button
                        colorScheme="red"
                        onClick={handleDelete}
                        isLoading={isPending}
                        loadingText="Deleting...">
                        Delete Partner
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DeletePartnerModal;
